module.exports = __webpack_public_path__ + "img/keyboard-arrow-bottom-left.d2ad5740.svg";